module.exports = __webpack_public_path__ + "img/controller.dc6436e5.svg";